export var TABS_CHANGE_TAB_TYPE = 'tabs/changeTab';